import "./namespace.js";
import "#/legacy/namespaces.js";
import "./filter_app_readiness.js";

// Opens the control of one finder filter, for a link or a prompt that points the visitor at it.
//
// A control is the element marked `data-doctor-finder-behaviour~="filter-control"`: the
// `FinderFilter` presenters and `doctor_finder_search_control` both write it, beside the
// `data-filter-name` that names the filter. An `sp-finder-filter` opens through its `open`
// property, any other control through `showDialog`, and one with neither on a click.
DoctorFinder.Helpers.FilterFocus = {
  CONTROL: '[data-doctor-finder-behaviour~="filter-control"]',

  // The control of the filter named `filterName`, or null.
  controlNamed(root, filterName) {
    const controls = Array.from(root.querySelectorAll(this.CONTROL));

    return controls.find((control) => control.dataset.filterName === String(filterName)) ?? null;
  },

  // The control holding `input`, which is the input itself for a filter that is its own control.
  controlOf(input) {
    return input?.closest(this.CONTROL) ?? null;
  },

  // Opens `control` through its own API; false when there was no control to open.
  open(control) {
    this.awaited = null;

    if (!control) {
      return false;
    }

    if (control.matches("sp-finder-filter")) {
      this.openFilterApp(control);
    } else if (typeof control.showDialog === "function") {
      control.showDialog();
    } else {
      control.click();
    }

    return true;
  },

  // Opens an `sp-finder-filter` once it has mounted, which is when its `open` property exists.
  // Of the controls asked to open before then, only the latest opens.
  openFilterApp(control) {
    this.awaited = control;

    DoctorFinder.Helpers.FilterAppReadiness.whenOperational(control).then(
      () => this.openAwaited(control),
      (error) => console.error(`sp-finder-filter failed to load; leaving ${control.dataset.filterName} closed`, error),
    );
  },

  openAwaited(control) {
    if (this.awaited === control) {
      control.open = true;
    }
  },
};
